import { inject, Injectable } from '@angular/core';

import { LocalStorageKeyBuilder } from '@core/common-legacy';
import { findCurrentMembershipSafe } from '@core/tellent-data';
import { TELLENT_INITIAL_CURRENT_USER } from '@core/tellent-types';

@Injectable({ providedIn: 'root' })
export class TellentClientLocalStorageKeyBuilder extends LocalStorageKeyBuilder {
  #currentUser = inject(TELLENT_INITIAL_CURRENT_USER);

  public buildScopedKey(key: string) {
    const me = findCurrentMembershipSafe(this.#currentUser);

    if (me && this.#currentUser?.currentOrgGuid) {
      return `tellent_client_${this.#currentUser?.currentOrgGuid}_${me.guid}_${key}`;
    }

    return `tellent_client_${performance.now()}`;
  }
}
